module.exports = __webpack_public_path__ + "img/logo-title.b814586d.png";